exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "form[data-v-9d5f27b6]{width:100%;height:100%;padding:25px;text-align:center}form button[data-v-9d5f27b6]{margin-top:35px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-9d5f27b6","scoped":true,"sourceMap":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/stripe/CardForm.vue
// module id = 1043
// module chunks = 22